module.exports = __webpack_public_path__ + "img/logo.dea2296a.png";